import React from "react";
import Tooltip from "@material-ui/core/Tooltip";

const estados_ativos = ['A.Ativo', 'V.Ativo (Formação)', 'T.Ativo (Em Formação E:MS)'];

const EstadoUtilizador = props => {
  const {nome, estado} = props;

  let nome_utilizador = <span style={{textDecoration: ![...estados_ativos, undefined].includes(estado) ? "line-through" : null}}>
        {nome}
      </span>;

  if (!estado) return nome_utilizador;

  let ativo = estados_ativos.includes(estado);

  if (!ativo) {
    nome_utilizador = <Tooltip
      title={estado.split('.')[1]}
      placement="top-start">
      {nome_utilizador}
    </Tooltip>;
  }

  return nome_utilizador;
}

export default EstadoUtilizador;
